import axios from 'axios';

export function getBottomNavigation(params) {
  return axios.post('/api/internal/bottomNavigation/list', params);
}
